import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import DKM from './DKM/DkmMonitoring';
import MS from './MS/MsMonitoring';
import Yeonoo from './Yeonoo/YeonooMonitoring';
import Yeonoo1 from './Yeonoo/YeonooMonitoring1';
import Yeonoo2 from './Yeonoo/YeonooMonitoring2';
import RawData from './RawData';
import SCT from './SCT/SctMonitoring';
import SCTCalendar from './SCT/Calendar';
import LineRecycle from './LineRecycle/LineRecycleMonitoring';
import LineRecycle1 from './LineRecycle/IntergratedMonitoring';
import LineRecycle2 from './LineRecycle/ProductionHistory';
import JOFoodMonitoring from './JOFood/JOFoodMonitoring';
import JOFoodFEMS from './JOFood/FEMS';
import JOFoodWeightSorting from './JOFood/WeightSorting';
import JsMonitoring from './JS/JsMonitoring';
import CncAnomalyDetection from './JS/CncAnomalyDetection';
import CncRawData from './JS/CncRawData';
import Test from './test';
import reportWebVitals from './reportWebVitals';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
//import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Routes>
      <Route path="/dkm" element={<DKM />} />

      <Route path="/ms-label" element={<MS />} />

      <Route path="/yeonoo" element={<Yeonoo />} />
      <Route path="/yeonoo/1" element={<Yeonoo1 />} />
      <Route path="/yeonoo/2" element={<Yeonoo2 />} />
      <Route path="/yeonoo/raw-data" element={<RawData />} />

      <Route path="/sct" element={<SCT />} />
      <Route path="/sct/calendar" element={<SCTCalendar />} />
      
      <Route path="/line-recycle" element={<LineRecycle />} />
      <Route path="/line-recycle/1" element={<LineRecycle1 />} />
      <Route path="/line-recycle/2" element={<LineRecycle2 />} />

      <Route path="/jo-food" element={<JOFoodMonitoring />} />
      <Route path="/jo-food/1" element={<JOFoodFEMS />} />
      <Route path="/jo-food/2" element={<JOFoodWeightSorting />} />

      <Route path="/js" element={<JsMonitoring />} />
      <Route path="/js/1" element={<CncAnomalyDetection />} />
      <Route path="/js/2" element={<CncRawData />} />

      <Route path="/test" element={<Test />} />
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
